import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import moment from "moment";

import SummeryBox from "../../shared/SummeryBox";
import CollapseComponent from "../../shared/Shop/CollapseComponent";
import RenderDateDisplay from "../../shared/RenderDateDisplay";

import Form from "../../shared/Form/Form";
import FormFrame from "../../shared/Form/FormFrame";
import FormFeild from "../../shared/Form/FormHelpers/FormFeild";
import { createBooking, clearBooking } from "../../../actions";
import { toast } from "react-toastify";
import authService from "../../../services/auth-service";

import ClinicHorizontalCard from "./ClinicHorizontalCard";

class ClinicsConfirmBooking extends Form {
  constructor() {
    super();
    
    this.state = {
      data: {
       
        date: "",
        time:"",
        id: "",
        product: {},
        
        transferNumber: "",
       
        totalPrice: 0,
      },
      formError: false,
      formErrorMessage: "",
      formSuccess: false,
      formData: {
        transferNumber: {
          element: "input",
          value: "",
          config: {
            name: "transferNumber",
            type: "text",
            placeholder: "رقم حوالة الامتياز*",
          },
          validation: {
            required: true,
          },
          valid: true,
          touched: false,
          validationMessage: "",
        },
      
      },
    };
  }
  
  componentDidMount() {
    const {state}= this.props.location
    if (state && state.filterData) {
      
      const nwData = { ...this.state.data };
      Object.keys(state.filterData).map(
        (key, i) => (nwData[key] = state.filterData[key])
      );
     
      nwData.totalPrice =  nwData.product.price;
      this.setState({
        data: nwData,
      });
    } else {
      this.props.history.replace({
        pathname: "/clinics",
      });
    }
  }
  emptyErrors = () => {};
 
  generateBookingData = () => {
    const nwData = {};
    const stateData = { ...this.state.data };
    Object.keys(stateData).forEach((key) => {
      if (key !== "product" && key !== "id") {
      key!=="date" ?
          nwData[key] = stateData[key]:nwData[key] = stateData[key]?stateData[key]:moment().locale('en-ca').format("YYYY-MM-DD")
       
      } else if (key === "product") {
        nwData[key] = { _id: stateData[key]._id };
      }
    });
    
    this.props
      .createBooking(nwData, "bookClinic")
      .then((e) => {
        
      })
      .catch((errors) => {
        errors && errors.length > 0 && toast.error(errors[0].message);
      });
  };
  submitAction = (data) => {
    this.setState(
      {
        data: {
          ...this.state.data,
          transferNumber: data.transferNumber,
          
        },
      },
      () => this.generateBookingData()
    );
  };
  renderFormFeilds = () => {
    const feilds = Object.keys(this.state.formData);

    return feilds.map((feild, i) => (
      <FormFeild
        id={feild}
        key={i}
        formData={this.state.formData[feild]}
        change={(element) => this.updateForm(element)}
        isError={this.state.formError}
      />
    ));
  };
  componentDidUpdate() {
    const { errors, success } = this.props.booking;

    if (success || (errors && errors.length > 0)) {
      this.props.clearBooking();
    }
  }
  render() {
    const { data } = this.state;
    const { bookedId, errors, isLoading, success } = this.props.booking;


    if (!authService.isAuthenticated()) {
      return (
        <Redirect
          to={{ pathname: "/general/login", state: { from: this.props.location } }}
        />
      );
    }
    if (success && bookedId !== "") {
      return <Redirect
          to={{ pathname: `/clinics/bookingDetail/${bookedId}`, state: { success: true } }}
        />
    }
    return (
      <div className="container">
        <div className="row flex-wrap align- confirmBooking">
          <div className="col col-7 col-no-sidePadding">
            <RenderDateDisplay date={data.date?data.date:new Date()} time={data.time} />
            <FormFrame
              footerComponent={() => (
                <p>
                  تذكر: انت تدفع العربون فقط، بقية المبلغ يسلم للمزود عند
                  الحضور.
                </p>
              )}
              style={{ marginBottom: "5rem" }}
              title="ادخل بقية البيانات"
              titleClasses="mg-bottom theme-clinics"
              formClasses="border-none no-margin shadow-third"
            >
              <form
                className="form mg-top"
                onSubmit={this.submitForm}
                action=""
              >
                {this.renderFormFeilds()}
               
              </form>
            </FormFrame>
            <CollapseComponent
              title="تفاصيل الطلب "
              children={true}
              initOpen={true}
            >
              <ClinicHorizontalCard
                photos={data.product.photos}
                price={data.product.price}
                
                waitingTime={data.waitingTime}
                name={data.product.name}
              />
            </CollapseComponent>
          </div>

          <div className="col col-5 col-no-sidePadding">
            <div
              style={{ marginBottom: "6rem" }}
              className="general-form border-none shadow-third "
            >
              <div className="general-form__title theme-clinics">الخلاصة</div>
              <div className="general-form__body no-padding">
                <SummeryBox
                  onClick={this.submitForm}
                  size="medium"
                  price={data.product.price }
                  percentage={
                    data.product.orboon && data.product.orboon.percentage
                  }
                  isLoading={isLoading}
                  orboon={
                    data.product.orboon &&
                    data.product.orboon.priceToPay
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  booking: state.booking,
});

const mapDispatchToProps = { createBooking, clearBooking };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ClinicsConfirmBooking);
